import React from 'react';
import { ShieldAlert, ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function StandaloneTaskError({ error, onBackToHome }) {
    const { t: translate } = useTranslation('tasks');

    return (
        <div className="task-standalone-error">
            <ShieldAlert size={32} />
            <h2>{translate(error.type === 'forbidden' ? 'modal.standaloneForbiddenTitle' : 'modal.standaloneNotFoundTitle')}</h2>
            <p>
                {error.type === 'forbidden'
                    ? translate('modal.standaloneForbiddenBody', { spaceName: error.spaceName || '' })
                    : translate('modal.standaloneNotFoundBody')}
            </p>
            <button type="button" className="task-standalone-back-btn" onClick={onBackToHome}>
                <ChevronLeft size={16} />
                {translate('modal.backToHome')}
            </button>
        </div>
    );
}
